import React, { useEffect, useState } from "react";
import { getQueryPath } from "../url";

export interface IRoute extends Partial<HTMLDivElement> {
  queryPath: string;
  element: JSX.Element;
}

export const Route = ({ queryPath, element: Element, ...rest }: IRoute) => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const searchParamChangeHandler = () => {
      if (getQueryPath() === queryPath) {
        setShow(true);
      } else {
        setShow(false);
      }
    };
    searchParamChangeHandler();
    window.addEventListener("popstate", searchParamChangeHandler);
    return () => {
      window.removeEventListener("popstate", searchParamChangeHandler);
    };
  }, [queryPath]);

  if (show) {
    return Element;
  } else {
    return <></>;
  }
};
